"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BreadcrumbButton", {
    enumerable: true,
    get: function() {
        return BreadcrumbButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useBreadcrumbButton = require("./useBreadcrumbButton");
const _renderBreadcrumbButton = require("./renderBreadcrumbButton");
const _useBreadcrumbButtonStylesstyles = require("./useBreadcrumbButtonStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const BreadcrumbButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useBreadcrumbButton.useBreadcrumbButton_unstable)(props, ref);
    (0, _useBreadcrumbButtonStylesstyles.useBreadcrumbButtonStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useBreadcrumbButtonStyles_unstable')(state);
    return (0, _renderBreadcrumbButton.renderBreadcrumbButton_unstable)(state);
});
BreadcrumbButton.displayName = 'BreadcrumbButton';
